import React, { Component } from "react";
import PropTypes from "prop-types";
import { Layout, Menu } from "antd";

import { InfoTable } from "./info_table";
import { MENU_KEYS } from "./constants";

class Info extends Component {
  state = {
    selectedMenuKey: MENU_KEYS.FINANCIAL_ELEMENTS,
    tableHeight: window.innerHeight - 150
  };

  logClickAction = (component, payload) => {
    this.props.onLogAction(component, "click", payload);
  };

  onMenuSelect = item => {
    this.logClickAction("menu", { target: item.key });
    this.setState({
      selectedMenuKey: item.key
    });
  };

  componentDidMount() {
    this.props.onLogAction("", "load", { state: this.state });
  }

  render() {
    const { tableHeight, selectedMenuKey } = this.state;
    return (
      <div className="cp-info">
        <Layout>
          <Layout.Sider
            width={220}
            style={{
              background: "#dedede",
              overflowY: "auto",
              height: "100vh"
              // position: "fixed",
              // left: 0
            }}
          >
            <Menu
              onSelect={this.onMenuSelect}
              mode="inline"
              defaultSelectedKeys={[selectedMenuKey]}
              defaultOpenKeys={[MENU_KEYS.FINANCIAL]}
              style={{ height: "100%", borderRight: 0 }}
            >
              <Menu.SubMenu
                key={MENU_KEYS.FINANCIAL}
                title={<span>Financial</span>}
              >
                <Menu.Item key={MENU_KEYS.FINANCIAL_ELEMENTS}>
                  Elements
                </Menu.Item>
                <Menu.Item key={MENU_KEYS.FINANCIAL_VARIABLES}>
                  Variables
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu key={MENU_KEYS.SYSTEM} title={<span>System</span>}>
                <Menu.Item key={MENU_KEYS.SYSTEM_ELEMENTS}>Elements</Menu.Item>
                <Menu.Item key={MENU_KEYS.SYSTEM_VARIABLES}>
                  Variables
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu key={MENU_KEYS.UNITS} title={<span>Unit</span>}>
                <Menu.Item key={MENU_KEYS.UNITS_ELEMENTS}>Elements</Menu.Item>
                <Menu.Item key={MENU_KEYS.UNITS_VARIABLES}>Variables</Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu
                key={MENU_KEYS.INTERCONN}
                title={<span>Interconnector</span>}
              >
                <Menu.Item key={MENU_KEYS.INTERCONN_ELEMENTS}>
                  Elements
                </Menu.Item>
                <Menu.Item key={MENU_KEYS.INTERCONN_VARIABLES}>
                  Variables
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu key={MENU_KEYS.LOAD} title={<span>Load</span>}>
                <Menu.Item key={MENU_KEYS.LOAD_ELEMENTS}>Elements</Menu.Item>
                <Menu.Item key={MENU_KEYS.LOAD_VARIABLES}>Variables</Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </Layout.Sider>
          <Layout.Content style={{ padding: "10px" }}>
            <InfoTable tableHeight={tableHeight} menuKey={selectedMenuKey} />
          </Layout.Content>
        </Layout>

        {/*<Footer />*/}
      </div>
    );
  }
}

Info.propTypes = {
  onLogAction: PropTypes.func.isRequired
};
export default Info;



// WEBPACK FOOTER //
// ./src/views/info/Info.jsx